import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { FiQuizHelperService } from '@fi-app/fi-onboarding/fi-quiz/fi-quiz-helper.service';
import { FiQuizQuestionType } from '@fi-app/fi-onboarding/fi-quiz/fi-quiz-enums';

@Component({
    selector: 'fi-quiz-question-cards-list',
    templateUrl: './quiz-question-cards-list.component.html',
    styleUrls: ['./quiz-question-cards-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-quiz-question-cards-list' },
    standalone: false,
})
export class FiQuizQuestionCardsListComponent {
    private fiQuizHelperService = inject(FiQuizHelperService);

    protected quizQuestionsList = this.fiQuizHelperService.quizQuestionsList;
    protected connectedDropListId = this.fiQuizHelperService.quizAddedQuestionsDropListId;
    protected dropListId = this.fiQuizHelperService.quizAvailableQuestionTypesDropListId;

    protected onQuestionCardClick(questionType: FiQuizQuestionType): void {
        this.fiQuizHelperService.addNewQuizQuestion(questionType);
    }
}
